import * as React from 'react';
import { connect } from 'react-redux';
import { DropdownField, TextField } from '@ane/ui-components/lib/components/FormikFormFields';
import { StepContainer } from '@ane/ui-components/lib/components/StepContainer';
import { TagPickerField } from '@ane/ui-components/lib/components/FormikFormFields/TagPickerField';
import { dataSourceCreateComponentsName, genErrorMessageDataSourceName, getPlaceHolder, } from '../../utils/DataSourceFormikSettingsUtils';
import { showStudioExperience } from '@ane/exp-ux/lib/components/GetWorkspace/GetWorkspace.utils';
import { CreateStepTitle } from '../CreateWizard/CreateSteps';
import { FormHeading } from '@ane/ui-components/lib/components/FormHeading';
import { FormSection } from '@ane/ui-components/lib/components/FormSection';
import EnvironmentService from '@ane/core/lib/services/EnvironmentService';
import { LoadPickSubscribersField } from '@ane/exp-ux/lib/components/Subscribers/LoadPickSubscribersField';
import { ENTITY_TYPES } from '@ane/exp-data/lib/models/SubscriberModels';
import { convertSubscribers, convertSubscribersV2 } from '@ane/exp-ux/lib/components/Subscribers/Subscriber.utils';
import _ from 'lodash';
import { requestCompleted, requestPending } from '@ane/core/lib/models/IAsyncWrapper/IAsyncWrapper.utils';
import { NOTIFICATION_CATEGORY } from '@ane/exp-data/lib/constants/NotificationSettingConstants';
import { DataSourceTypeOptions, DataSourceTypes } from '../../../../constants/DataSource.constants';
const mapStateToProps = (state) => {
    var _a, _b, _c;
    return {
        isStudio: showStudioExperience(state.workspace_data.workspace.data),
        workspaceId: (_b = (_a = state.currentUserDetails.userAffinity) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.workspaceId,
        isMsftWorkspace: (_c = state.workspace_data.workspace.data) === null || _c === void 0 ? void 0 : _c.IsMsftWorkspace,
        subscribersAsync: state.subscribers.items,
        subscribersAsyncV2: state.subscribersV2.items,
    };
};
const mapDispatchToProps = {};
export class BasicInfoComponent extends React.Component {
    componentDidUpdate(preProps) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
        if (EnvironmentService.enableUnifiedAPIOfSubscribeMode()) {
            if (requestPending((_a = preProps.subscribersAsyncV2) === null || _a === void 0 ? void 0 : _a.status) && requestCompleted((_b = this.props.subscribersAsyncV2) === null || _b === void 0 ? void 0 : _b.status)) {
                let subscribers = !!((_e = (_d = (_c = this.props.subscribersAsyncV2) === null || _c === void 0 ? void 0 : _c.data) === null || _d === void 0 ? void 0 : _d.value) === null || _e === void 0 ? void 0 : _e.length)
                    ? (_g = (_f = this.props.subscribersAsyncV2) === null || _f === void 0 ? void 0 : _f.data) === null || _g === void 0 ? void 0 : _g.value[0].subscribers
                    : [];
                this.props.formikProps.initialValues.subscribers = convertSubscribersV2(subscribers);
            }
        }
        else {
            if (requestPending((_h = preProps.subscribersAsync) === null || _h === void 0 ? void 0 : _h.status) && requestCompleted((_j = this.props.subscribersAsync) === null || _j === void 0 ? void 0 : _j.status)) {
                this.props.formikProps.initialValues.subscribers = convertSubscribers((_l = (_k = this.props.subscribersAsync) === null || _k === void 0 ? void 0 : _k.data) === null || _l === void 0 ? void 0 : _l.subscribers);
            }
        }
    }
    render() {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        let shouldResetSubscriberList = false;
        if (EnvironmentService.enableUnifiedAPIOfSubscribeMode()) {
            let subscribers = !!((_c = (_b = (_a = this.props.subscribersAsyncV2) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.value) === null || _c === void 0 ? void 0 : _c.length)
                ? (_e = (_d = this.props.subscribersAsyncV2) === null || _d === void 0 ? void 0 : _d.data) === null || _e === void 0 ? void 0 : _e.value[0].subscribers
                : [];
            if (_.isEqual(this.props.formikProps.values.subscribers, convertSubscribersV2(subscribers))) {
                shouldResetSubscriberList = true;
            }
        }
        else {
            if (_.isEqual(this.props.formikProps.values.subscribers, convertSubscribers((_g = (_f = this.props.subscribersAsync) === null || _f === void 0 ? void 0 : _f.data) === null || _g === void 0 ? void 0 : _g.subscribers))) {
                shouldResetSubscriberList = true;
            }
        }
        return (React.createElement(StepContainer, { className: "create-basic-info-tab" },
            !this.props.isUpdateDataSource && (React.createElement(FormHeading, { pageTitle: CreateStepTitle.Basic }, "This is where you enter basic information about your data source.")),
            React.createElement(FormSection, null,
                React.createElement(TextField, { name: `name`, innerTextFieldProps: {
                        label: 'Data source name',
                        onGetErrorMessage: (value) => {
                            return this.props.formikProps.touched.name ? genErrorMessageDataSourceName(value) : '';
                        },
                        maxLength: 100,
                        disabled: !this.props.isReadOnly && !!this.props.isUpdateDataSource,
                        isReadOnly: !!this.props.isReadOnly,
                        required: true,
                        ariaLabel: 'Please enter data source name',
                        description: getPlaceHolder(dataSourceCreateComponentsName.basicinfo, 'data source name'),
                    } }),
                EnvironmentService.enableSampleDataSource() && (React.createElement(DropdownField, { label: "Data source use type", name: `dataSourceType`, ariaLabel: "Data source use type", labelProps: {
                        iconProps: {
                            calloutProps: {
                                content: 'Please provide a data source use type, "Main" for normal scenario, "Sample" for quick metric preview.',
                            },
                        },
                    }, options: DataSourceTypeOptions, selectedKey: (_j = (_h = this.props.formikProps) === null || _h === void 0 ? void 0 : _h.values) === null || _j === void 0 ? void 0 : _j.dataSourceType, required: true, isReadOnly: !!this.props.isReadOnly, disabled: !!this.props.isReadOnly || !!this.props.isUpdateDataSource, defaultSelectedKey: DataSourceTypes.Main })),
                React.createElement(TagPickerField, { name: `owners`, label: 'Data source contacts', showSuggestions: false, placeholder: getPlaceHolder(dataSourceCreateComponentsName.basicinfo, 'Owners'), required: true, tagPickerProps: {
                        ariaLabel: 'Owners list',
                        removeButtonAriaLabel: 'Owners List remove',
                        allowNewItems: true,
                        isReadOnly: !!this.props.isReadOnly,
                    } }),
                React.createElement(LoadPickSubscribersField, { name: 'subscribers', required: false, isUpdateEntity: !!this.props.isUpdateDataSource, subscribers: this.props.formikProps.values.subscribers, workspaceId: this.props.workspaceId, entityType: ENTITY_TYPES.DATASOURCE, entityExternalId: this.props.formikProps.values.name, isReadOnly: !!this.props.isReadOnly, shouldReset: shouldResetSubscriberList, notificationCategory: NOTIFICATION_CATEGORY.DataSourceNotifications }))));
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(BasicInfoComponent);

//# sourceMappingURL=BasicInfoComponent.js.map
